module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"gatsby-starter-default","short_name":"starter","start_url":"/","background_color":"#11AAFF","theme_color":"#11AAFF","display":"minimal-ui","icon":"src/images/azybaoLogo-Visual-600x600-JH-180703-v1.png","cache_busting_mode":"query","include_favicon":true,"legacy":true,"theme_color_in_head":true,"cacheDigest":"a444a14f0a4293f873ac880dd4bf4289"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
